// 代理事件方法列表
var keydownFunList = []
var resizeFunList = []
var resizeFunListEvent = {}
var clickFunList = []
var clickFunListEvent = {}

export default {
    /** 深拷贝
     * @param {*} obj       复制对象
     * @param {*} filter    过滤对象
     * @param {*} cache
     */
    deepCopy(obj, filter = [], cache = []) {
        // typeof [] => 'object'
        // typeof {} => 'object'
        if (obj === null || typeof obj !== 'object') {
            return obj
        }
        // 如果传入的对象与缓存的相等, 则递归结束, 这样防止循环
        /**
         * 类似下面这种
         * var a = {b:1}
         * a.c = a
         * 资料: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Errors/Cyclic_object_value
         */
        const hit = cache.filter((c) => c.original === obj)[0]
        if (hit) {
            return hit.copy
        }
        const copy = Array.isArray(obj) ? [] : {}
        // 将copy首先放入cache, 因为我们需要在递归deepCopy的时候引用它
        cache.push({
            original: obj,
            copy,
        })
        Object.keys(obj).forEach((key) => {
            if (filter.indexOf(key) == -1) {
                copy[key] = this.deepCopy(obj[key], filter, cache)
            }
        })
        return copy
    },
    /** 获取数据长度
     * @param  {[type]} jsonData [统计数据]
     * @param  {[type]} onGetArr [不用统计元素]
     */
    getLength(jsonData, onGetArr = []) {
        if (!jsonData) {
            return 0
        }
        var length = jsonData.length
        if (typeof length == 'undefined' || !jsonData[0]) {
            length = 0
            for (var ever in jsonData) {
                if (onGetArr.indexOf(ever) == -1) {
                    length++
                }
            }
        }
        return length
    },
    // 将json对转换为表格数据
    getTableData(data) {
        var tableData = []
        for (var o in data) {
            let tb = {
                name: o,
                val: data[o]
            }
            tableData.push(tb)
        }
        return tableData
    },
    // 生成唯一id
    getUniqueId() {
        // ('xxxxxxxx-'+((new Date()).valueOf())+'-xxxx-4xxx-yxxx-xxxxxxxxxxxx')
        return ('yxxxx-' + new Date().valueOf() + '-4xxx-xxxxxxxx').replace(
            /[xy]/g,
            function(c) {
                var r = (Math.random() * 16) | 0,
                    v = c == 'x' ? r : (r & 0x3) | 0x8
                return v.toString(16)
            }
        )
    },
    /** 判断数组或对象是否相等
     * @param  {[type]} a [数组或对象]
     * @param  {[type]} b [数组或对象]
     * @param  {[type]} onGetArr [不用比较字段]
     */
    equar(a, b, onGetArr = []) {
        if (this.getLength(a, onGetArr) != this.getLength(b, onGetArr)) {
            // console.log(this.getLength(a, onGetArr) , this.getLength(b, onGetArr), onGetArr)
            // console.log(a , b)
            return false
        }
        // 循环遍历数组的值进行比较
        for (let i in a) {
            if (onGetArr.indexOf(i) == -1) {
                if (typeof a[i] == 'object' && a[i] != null) {
                    if (typeof b[i] == 'object' && b[i] != null) {
                        let data = this.equar(a[i], b[i], onGetArr)
                        if (!data) {
                            // console.log(a , b)
                            // console.log(i, a[i] , b[i])
                            return false
                        }
                        continue
                    } else {
                        // console.log(i, a[i] , b[i])
                        return false
                    }
                }

                if (a[i] != b[i]) {
                    if ((a[i] == '' || a[i] == null) && (b[i] == '' || b[i] == null)) {} else {
                        // console.log(i, a[i] , b[i])
                        return false
                    }
                }
            }
        }
        return true
    },
    /** 文字复制到剪贴板
     * @param {Object} text     要复制的内容
     * @param {Object} callback 回调
     */
    copyText(text, callback) {
        var tag = document.createElement('textarea')
        tag.setAttribute('id', 'cp_hgz_input')
        tag.value = text
        document.getElementsByTagName('body')[0].appendChild(tag)
        document.getElementById('cp_hgz_input').select()
        document.execCommand('copy')
        document.getElementById('cp_hgz_input').remove()
        if (callback) {
            callback(text)
        }
    },
    // 数组根据指定元素排序
    sortAsc(arr, field) {
        let compare = (propertyName) => {
            return function(object1, object2) {
                var value1 = object1[propertyName]
                var value2 = object2[propertyName]
                if (value2 < value1) {
                    return 1
                } else if (value2 > value1) {
                    return -1
                } else {
                    return 0
                }
            }
        }
        arr.sort(compare(field))
    },
    sortDesc(arr, field) {
        let compare = (propertyName) => {
            return function(object1, object2) {
                var value1 = object1[propertyName]
                var value2 = object2[propertyName]

                if (value2 < value1) {
                    return -1
                } else if (value2 > value1) {
                    return 1
                } else {
                    return 0
                }
            }
        }
        arr.sort(compare(field))
    },

    /*********** Url地址操作 ***********/
    // 将json对象转 url参数
    parseParamUrl(param, key) {
        var paramStr = ''
        if (
            typeof param == 'string' ||
            typeof param == 'number' ||
            typeof param == 'boolean'
        ) {
            paramStr += '&' + key + '=' + encodeURIComponent(param)
            // paramStr += "&" + key + "=" + param;
        } else {
            // $.each(param, function(i) {
            // 	vark = key == null ? i : key + (paraminstanceof Array ? "[" + i + "]" : "." + i);
            // 	paramStr += '&' + parseParam(this, k);
            // });
            for (var o in param) {
                var k =
                    key == null ?
                    o :
                    key + (param instanceof Array ? '[' + o + ']' : '.' + o)
                paramStr += '&' + this.parseParamUrl(param[o], k)
            }
        }
        return paramStr.substr(1)
    },
    /** 将 url参数 转 json对象
     * @param {Object} url [处理的字符串]
     * @param {Object} dataType [返回的数据格式 <false:返回键值对|true:返回二维数组格式>]
     */
    getRequestUrl(url, dataType = false) {
        var theRequest = new Object()
        var strs = url
        if (url.indexOf('?') != -1) {
            strs = strs.substr(1)
        }

        strs = strs.split('&')
        for (var i = 0; i < strs.length; i++) {
            if (strs[i]) {
                let nowData = strs[i].split('=')
                let val = typeof nowData[1] == 'undefined' ? '' : unescape(nowData[1])
                let name = nowData[0]
                if (dataType) {
                    theRequest[i] = {
                        name: name,
                        val: val,
                    }
                } else {
                    theRequest[name] = typeof val == 'undefined' ? '' : unescape(val)
                }
            }
        }

        return theRequest
    },
    // 拼接get参数，合成完整地址
    urlJoinParam(query, requestUrl) {
        let getParam = typeof query == 'string' ? query : this.parseParamUrl(query)
        if (getParam != '') {
            if (requestUrl.indexOf('?') != -1) {
                let end = requestUrl.slice(requestUrl.length - 1, requestUrl.length)
                if (end == '?' || end == '&') {
                    requestUrl += getParam
                } else {
                    requestUrl += '&' + getParam
                }
            } else {
                requestUrl += '?' + getParam
            }
        }
        return requestUrl
    },
    // 获取get参数
    GetQueryString(name) {
        var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
        var r = window.location.search.substr(1).match(reg)
        if (r != null) return unescape(r[2])
        return null
    },

    /*********** 数据操作 ***********/
    // json字符串判断
    isJsonStr(str) {
        if (typeof str == 'string' && str != '') {
            try {
                var obj = JSON.parse(str)
                if (typeof obj == 'object' && obj) {
                    return obj
                } else {
                    return false
                }
            } catch (e) {
                // console.log('error：'+str+'!!!'+e);
                return false
            }
        }
        return false
        // console.log('It is not a string!')
    },
    // 数组判断
    isArrayFn(value) {
        if (typeof Array.isArray === 'function') {
            return Array.isArray(value)
        } else {
            return Object.prototype.toString.call(value) === '[object Array]'
        }
    },
    // 数字字符串判断
    isNumber(val) {
        var regPos = /^\d+(\.\d+)?$/ //非负浮点数
        var regNeg =
            /^(-(([0-9]+\.[0-9]*[1-9][0-9]*)|([0-9]*[1-9][0-9]*\.[0-9]+)|([0-9]*[1-9][0-9]*)))$/ //负浮点数
        if (regPos.test(val) || regNeg.test(val)) {
            return true
        } else {
            return false
        }
    },
    // 判断是否是xml字符串，是的话返回xml对象
    IsXml(str) {
        var xmlStrDoc = null
        if (window.DOMParser) {
            // Mozilla Explorer
            var parser = new DOMParser()
            xmlStrDoc = parser.parseFromString(str, 'text/xml')
        } else {
            // Internet Explorer
            xmlStrDoc = new ActiveXObject('Microsoft.XMLDOM')
            xmlStrDoc.async = 'false'
            xmlStrDoc.loadXML(str)
        }

        try {
            let error =
                xmlStrDoc.childNodes[0].childNodes[0].childNodes[0].childNodes[0]
                .textContent
            if (error == 'This page contains the following errors:') {
                return false
            }
        } catch (e) {
            return xmlStrDoc
        }
    },
    // xml数据转成json对象的数据
    xmlTojson(xmlObj) {
        let obj = {}
        let isObj = true

        if (xmlObj.children && xmlObj.children.length > 0) {
            for (let i = 0; i < xmlObj.children.length; i++) {
                let nowNodeData = {}
                let node = xmlObj.children[i]

                if (isObj && obj[node.tagName]) {
                    let first = obj[node.tagName]
                    obj[node.tagName] = []
                    obj[node.tagName].push(first)
                    isObj = false
                }

                for (
                    let attrIndex = 0; attrIndex < node.attributes.length; attrIndex++
                ) {
                    let attr = node.attributes[attrIndex]
                    nowNodeData['-' + attr.name] = attr.textContent
                }

                if (node.children.length > 0) {
                    let chil = this.xmlTojson(node)
                    for (let i in chil) {
                        nowNodeData[i] = chil[i]
                    }
                } else {
                    if (node.attributes.length == 0) {
                        nowNodeData = node.textContent
                    } else {
                        if (node.textContent != '') {
                            nowNodeData['#text'] = node.textContent
                        }
                    }
                }

                if (nowNodeData != '') {
                    if (obj[node.tagName]) {
                        obj[node.tagName].push(nowNodeData)
                    } else {
                        obj[node.tagName] = nowNodeData
                    }
                }
                // isObj[node.tagName] = nowNodeData
            }
        }
        return obj
    },

    /** Json字符串格式化
     * @param {*} str   [Json字符串]
     * @param {*} isZip [是否压缩：<默认:false|true>]
     */
    jsonFormat(str, isZip = false) {
        str = JSON.stringify(JSON.parse(str.replace(/(:)(\s+\d+)/g, '$1"getapi_int($2)"')), null, !isZip?4:0);
        return str.replace(/(:\s)+\"getapi_int\((\s+\d+)\)\"/g, (p, s1, s2)=>{
            return s1+s2.trim();
        });
    },

    /*********** 事件代理 ***********/
    // 按键事件代理
    wKeydown(fun) {
        keydownFunList[fun] = fun
        document.onkeydown = (e) => {
            let keyCode = e.keyCode || e.which || e.charCode
            let key = e.key
            let ctrlKey = e.ctrlKey
            let shiftKey = e.shiftKey
            let altKey = e.altKey
            let run = undefined
            for (let o in keydownFunList) {
                run = keydownFunList[o](e, keyCode, ctrlKey, shiftKey, altKey, key)
            }
            return run
        }
    },
    
    // 大小改变事件代理
    wResize(fun, id = '') {
        let _this = this
        let name = fun + id
        resizeFunList[name] = fun
        // window.addEventListener('resize',fun)
        window.onresize = function(e) {
            resizeFunListEvent = e
            return _this.wResizeRun(e)
        }
        return name
    },
    // 移除代理事件
    wRemoveResize(name) {
        delete resizeFunList[name]
    },
    // 执行窗口改变代理事件
    wResizeRun(e){
        let run = undefined
        for (let o in resizeFunList) {
            run = resizeFunList[o](e?e:resizeFunListEvent)
        }
        return run 
    },
    
    // 全局点击事件代理
    wOnClick(fun, id = '') {
        let name = fun + id
        clickFunList[name] = fun
        let run = undefined
        window.onclick = function(e) {
            clickFunListEvent = e
            for (let o in clickFunList) {
                run = clickFunList[o](e)
            }
            return run
        }
        return name
    },
    wRemoveOnClick(name) {
        delete clickFunList[name]
    },

    /*********** 浏览器级缓存设置 ***********/
    getCache(name) {
        return localStorage.getItem(name)
    },
    setCache(name, val) {
        // return localStorage.setItem(name, val)
        try {
            return localStorage.setItem(name, val)
        } catch (e) {
            // localStorage容量不够，根据保存的时间删除已缓存到 localStorage
            if (e.name.toUpperCase().indexOf('QUOTA') >= 0) {
                let item;
                const tempArr = [];
                // 先把所有的缓存对象来出来，放到 tempArr 里
        
                for (item in localStorage) {
                    let isDel = false
                    for (let o of ['menuHistoryData','menuData','teamItemList','teamUserGroupList']) {
                        if (item.indexOf(o) != -1) {
                            isDel = true
                            break
                        }
                    }
                    if (isDel) {
                        tempArr.push(localStorage[item]);
                    }
                }
                console.log(tempArr)
                // 如果有缓存对象
                if (tempArr.length) {
                    // 按缓存时间升序排列数组
                    tempArr.sort((a, b) =>{ 
                        console.log(a.stamp, b.stamp)
                        return a.stamp - b.stamp
                    });
                    console.log(tempArr)
                    // // 删除缓存时间最早的
                    // localStorage.removeItem(tempArr[0].key);
                    // // 删除后在再添加，利用递归完成
                    // addSessionStorage(key, storeObj);
                }
            }
        }
    },
    delCache(name) {
        return localStorage.removeItem(name)
    },
    /** 清除所有数据
     * @param {Arrayu} all  不删除列表，数据名称包含该内容的都不会删除
     */
    delCacheAll(all = []) {
        if (all.length == 0) {
            localStorage.clear()
        } else {
            var len = localStorage.length // 获取长度
            var keyArr = []
            for (var i = 0; i < len; i++) {
                // 获取key 索引从0开始
                let getKey = localStorage.key(i)
                let isDel = true
                for (let o of all) {
                    if (getKey.indexOf(o) != -1) {
                        isDel = false
                        break
                    }
                }
                if (isDel) {
                    keyArr.push(getKey)
                }
            }
            for (let o of keyArr) {
                this.delCache(o)
            }
        }
    },

    /*********** 时间戳操作 ***********/
    // 获取当日凌晨时间戳
    getNowTimeStamp() {
        return new Date(new Date().setHours(0, 0, 0, 0)) / 1000
    },
    /** 获取当前时间戳
     *  @param  {[type]} isS [是否返回秒级时间戳（默认毫秒级）]
     */
    getNowTime(isS=false) {
        if(isS){
          return Date.parse(new Date())/1000
        }else{
          return new Date().valueOf()
        }
    },
    // 时间转时间戳
    getTimeDate(timeDate) {
        return new Date(timeDate).getTime()
    },
    /** 时间戳处理
     * @param  {[type]} tm      [时间戳（秒级）]
     * @param  {[type]} minutes [判断是否输出分秒,默认y/m/d（'y-m-d h:i:s ms'）]
     * @return {[type]}
     */
    getDate(tm, minutes) {
        function TimeJq(str, w) {
            if (str.indexOf(w) >= 0) {
                var sub = str.substring(str.indexOf(w) + 1, str.indexOf(w) + 2)
                if ('ymdhis'.indexOf(sub) >= 0) {
                    var sub = ''
                }
            }

            return sub
        }

        if (tm != 0) {
            if (Number(tm).toString().length != 13) {
                var timestamp = parseInt(tm) * 1000
            } else {
                var timestamp = parseInt(tm)
            }

            var mydate = new Date(timestamp)
            var today = ''
            var y, m, d, h, i, s, ms

            if (typeof minutes == 'undefined' || typeof minutes == 'number') {
                minutes = 'y/m/d'
            }

            var str = minutes.toLowerCase()
            y = TimeJq(str, 'y')
            m = TimeJq(str, 'm')
            d = TimeJq(str, 'd')
            h = TimeJq(str, 'h')
            i = TimeJq(str, 'i')
            s = TimeJq(str, 's')
            ms = TimeJq(str, 'ms')

            //返回年份
            if (typeof y != 'undefined') {
                today += mydate.getFullYear()
                today += y
            }
            //返回月份，因为返回值是0开始，表示1月，所以做+1处理
            if (typeof m != 'undefined') {
                today +=
                    mydate.getMonth() + 1 < 10 ?
                    '0' + (mydate.getMonth() + 1) :
                    mydate.getMonth() + 1
                today += m
            }
            //返回日期
            if (typeof d != 'undefined') {
                today +=
                    mydate.getDate() < 10 ? '0' + mydate.getDate() : mydate.getDate()
                today += d
            }
            //时
            if (typeof h != 'undefined') {
                today +=
                    mydate.getHours() < 10 ? '0' + mydate.getHours() : mydate.getHours()
                today += h
            }
            //分
            if (typeof i != 'undefined') {
                today +=
                    mydate.getMinutes() < 10 ?
                    '0' + mydate.getMinutes() :
                    mydate.getMinutes()
                today += i
            }
            //秒
            if (typeof s != 'undefined') {
                today +=
                    mydate.getSeconds() < 10 ?
                    '0' + mydate.getSeconds() :
                    mydate.getSeconds()
                today += s
            }
            //秒
            if (typeof ms != 'undefined') {
                today +=
                    mydate.getMilliseconds() < 10 ?
                    '0' + mydate.getMilliseconds() :
                    mydate.getMilliseconds()
            }
        } else {
            var today = tm
        }
        return today
    },
}
